import React from 'react';
import I18n from 'i18n-js';

import { RCAlertBox } from '@reverbdotcom/cadence/components';
import { US, currencies } from '@reverbdotcom/commons/src/constants';
import { core_apimessages_DirectCheckoutProfile_PayoutMethod } from '@reverbdotcom/commons/src/gql/graphql';

export const SELLER_SITE = 'seller_site';

interface IDraftDeleteErrorsProps {
  draftDeleteErrors?: Array<string>;
  setDraftDeleteErrors: React.Dispatch<React.SetStateAction<Array<string>>>;
}

export function canViewListingPaymentSetting(user, myDirectCheckoutProfile, walletOptInEnabled) {
  const eligibleForWalletPayout = user?.shopCountryCode === US && user?.shopCurrency === currencies.USD;
  const isShopPayoutMethodWallet = myDirectCheckoutProfile?.payoutMethodEnum === core_apimessages_DirectCheckoutProfile_PayoutMethod.WALLET;
  const dcProfileComplete = !!myDirectCheckoutProfile?.accountNumberLastFour;

  return eligibleForWalletPayout && walletOptInEnabled && !isShopPayoutMethodWallet && dcProfileComplete;
}

export function DeleteDraftListingErrors({
  draftDeleteErrors = [],
  setDraftDeleteErrors,
}: IDraftDeleteErrorsProps) {
  return (
    <div className="pb-8 pl-6 pr-4">
      <RCAlertBox
        type="error"
        onDismiss={() => {
          setDraftDeleteErrors([]);
        }}
      >
        {I18n.t(
          'discovery.listingsManagement.sellerListingCard.deleteDraftError',
        )}
        <ul className="ml-4">
          {draftDeleteErrors.map((errorMessage) => (
            <li key={errorMessage}>{errorMessage}</li>
          ))}
        </ul>
      </RCAlertBox>
    </div>
  );
}
